import React, { useState } from "react";
import Modal from "react-responsive-modal";
import ModalEmailAll from "root/Modals/ModalEmailAll";

const useModalEmailAll = () =>
{
    const [dialog, setDialog]  = useState ( { openState: false, provider_id: null, mode: null, user_id: null, onSaveCompleted: null, targetGroupString: null })   ;

    const activateEmailAll = ( provider_id, user_id, mode, onCompleteFunction, targetGroupString ) =>
    {
        setDialog ({ openState: true, provider_id: provider_id, user_id: user_id, mode: mode, onSaveCompleted: onCompleteFunction, targetGroupString: targetGroupString });
    }

    const onCloseModal = () =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted('cancel') ;
        }

        setDialog ({ openState: false, provider_id: null, user_id: null, mode: null, onSaveCompleted: null, targetGroupString: null });
    };

    const onSaveComplete = () =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted('saved') ;
        }

        // Close the dialog
        setDialog ({ openState: false, provider_id: null, user_id: null, mode: null, onSaveCompleted: null, targetGroupString: null });

    };

    const renderEmailAll = () =>
    {
        return (
            <Modal center focusTrapped={false} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalEmailAll onSaveCompleted={onSaveComplete} onClose={onCloseModal} provider_id={dialog.provider_id} user_id={dialog.user_id} params={dialog} mode={dialog.mode} targetGroupString={dialog.targetGroupString} />
            </Modal>
        )
    }

    return { renderEmailAll, activateEmailAll } ;
}

export default useModalEmailAll ;